module.exports = __webpack_public_path__ + "static/img/4_1.e033c9d5.jpg";